module.exports = __webpack_public_path__ + "static/media/06(1).b31b818d.jpg";